import React from "react";
import { Label, Input, FormGroup } from "reactstrap";
import "../../assets/scss/components/InputText/index.scss";

function InputText(props) {
  return (
    <React.Fragment>
      <div className="position-relative">
        <Label className={`inputLabel ${props.labelClass}`} for={props.forName}>
          {props.labelName}
          {props.mandatory && <span className="mandate_mark">*</span>}
        </Label>
        <FormGroup className="inputWrpper customInputBox">
          <Input
            type={props.inputType}
            name={props.inputName}
            placeholder={props.inputPlaceholder}
            value={props.customValue}
            disabled={props.disabledType}
            onChange={props.customOnChange}
            className={props.InputClass}
            id={props.InputId}
            autoComplete="off"
            maxLength={props.customMaxLength}
            minLength={props.customMinLength}
            max={props.customMax}
            min={props.customMin}
            required={props.customRequired}
            onKeyPress={props.customKeyPress}
            pattern={props.customPattern}
            style={props.style}
            onKeyDown={(e) => {
              if (props.inputType === "date") {
                e.preventDefault();
              }
            }}
            onBeforeInput={(e) => {
              if (props.inputType === "date") {
                e.preventDefault();
              }
            }}
          />

          {/* <Icon
          size={props.iconSize}
          className={props.IconClass}
          icon={props.customIcon}
        /> */}
        </FormGroup>
      </div>
    </React.Fragment>
  );
}
export default InputText;
